module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjMiIHkxPSIxNSIgeDI9IjYiIHkyPSIxNSIgc3Ryb2tlPSIjMUE4NUU0IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8bGluZSB4MT0iMTQiIHkxPSIxNSIgeDI9IjI2IiB5Mj0iMTUiIHN0cm9rZT0iIzFBODVFNCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSIxNSIgcj0iMyIgc3Ryb2tlPSIjMUE4NUU0IiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/field-icon-active/slider.svg
// module id = T6H9
// module chunks = 46